module.exports = __webpack_public_path__ + "static/media/twitter.e108113a.png";